__turbopack_context__.v({
  "desktopOnly": "R-q55G_desktopOnly",
  "mobileOnly": "R-q55G_mobileOnly",
  "root": "R-q55G_root",
});
